import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, ArrowRight, Loader } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useUser } from '../contexts/UserContext';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!user) {
      navigate('/login');
      return;
    }

    // Verify the session exists
    if (!sessionId) {
      navigate('/');
      return;
    }

    // Give Stripe webhook a moment to process
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [user, sessionId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader className="h-12 w-12 animate-spin text-orange-500 mx-auto mb-4" />
          <p className="text-gray-600">Verarbeite deine Zahlung...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="h-10 w-10 text-green-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Zahlung erfolgreich!</h1>
        
        <p className="text-gray-600 mb-8">
          Vielen Dank für deinen Kauf! Deine Zahlung wurde erfolgreich verarbeitet und dein Premium-Zugang wurde aktiviert.
        </p>
        
        <div className="space-y-4">
          <Link 
            to="/premium"
            className="block w-full bg-orange-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-orange-600 transition flex items-center justify-center space-x-2"
          >
            <span>Zu meinem Premium-Konto</span>
            <ArrowRight className="h-5 w-5" />
          </Link>
          
          <Link 
            to="/"
            className="block w-full bg-gray-100 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-200 transition"
          >
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;